import React from "react";
import AccHoursRenderer from "./AccHoursRenderer";
import constants from "../../../../../../../appConstants";

class AccruedHoursCellRenderer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accruedHours: props.value,
    };
  }

  refresh = (props) => {
    this.setState({ accruedHours: props.value });
    return true;
  };

  shouldComponentUpdate(_nextProps, nextState) {
    return this.state.accruedHours !== nextState.accruedHours;
  }

  render() {
    const { accruedHours } = this.state;
    const { column, context } = this.props;
    const allowedHOS =
      column.colId === "weeklyAccruedHours"
        ? Number(context.weeklyAllowedHOS)
        : constants.DAILY_ALLOWED_HOS;
    if (!accruedHours) {
      return null;
    }
    return (
      <AccHoursRenderer accruedHours={accruedHours} allowedHOS={allowedHOS} />
    );
  }
}

export default AccruedHoursCellRenderer;
